module.exports = __webpack_public_path__ + "static/media/cage.24fe49a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/cage.png
// module id = 251
// module chunks = 0